import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { getSystemLogs } from '@/api/system-log'
import IApiResponse from '@/types/api-response'
import IList from '@/types/list-result'
import IPagination from '@/types/pagination'

interface ISystemLogsState {
	loading: boolean
	logs: ISystemLogs[]
	pagination?: IPagination
}

export type TLevelError = 'error' | 'warn' | 'info' | 'verbose' | 'debug' | 'silly'

export interface ISystemLogs {
	_id: string
	timestamp: string
	level: TLevelError
	message: string
	hostname: string
    label?: string
	meta?: { [key: string]: any }
}

const initialState: ISystemLogsState = {
	loading: false,
	logs: [],
}

export const fetchSystemLogs = createAsyncThunk<
	IApiResponse<IList<ISystemLogs>>,
	{ params: { [key: string]: any }, cb?: (r: IApiResponse<IList<ISystemLogs>>) => void }
>('system_log/fetch_system_logs', async ({ params, cb }) => {
    const result = await getSystemLogs(params)
    if (typeof cb === 'function') {
        cb(result)
    }
	return result
})

const systemLogsSlice = createSlice({
	name: 'system_log',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchSystemLogs.pending, (state) => {
				state.loading = true
			})
			.addCase(fetchSystemLogs.fulfilled, (state, { payload }) => {
				state.loading = false
				state.pagination = payload.data!.pagination
				if (payload.success) {
					state.logs = payload.data!.records
				} else {
					state.logs = []
				}
			})
			.addCase(fetchSystemLogs.rejected, (state) => {
				state.loading = false
			})
	},
})

export default systemLogsSlice.reducer
